import React, { useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { useChallengeCompanyList } from '@repository/match';
import useClickAway from '@utils/hooks/useClickOutside';
import classnames from 'classnames/bind';
import styles from './positionSelect.module.scss';

const cx = classnames.bind(styles);

interface PositionSelectProps {
  selectedCompanySns: number[];
  setSelectedCompanySns: (state: number[]) => void;
}

const PositionSelect = ({ selectedCompanySns, setSelectedCompanySns }: PositionSelectProps) => {
  const { query } = useRouter();
  const sn = Number(query.sn);
  const { data: companyListData, isLoading: isLoadingCompanyListData } = useChallengeCompanyList(sn);

  const [selectOptionAreaVisible, setSelectOptionAreaVisible] = useState(false);
  const positionSelectRef = useRef<HTMLDivElement>(null);
  useClickAway(() => setSelectOptionAreaVisible(false), positionSelectRef);

  if (!companyListData || isLoadingCompanyListData) return null;

  const getSelectText = () => {
    const fistCompanyName = companyListData.challengeCompanies.filter(
      ({ companySn }) => companySn === selectedCompanySns[0],
    )[0]?.companyName;

    if (!selectedCompanySns.length) return '참여 기업';
    else if (selectedCompanySns.length === 1) return fistCompanyName;
    else return `${fistCompanyName} +${selectedCompanySns.length - 1}`;
  };

  const selectText = getSelectText();
  const positionEl = companyListData.challengeCompanies.map(({ companyName, companySn }) => {
    const checked = selectedCompanySns.includes(companySn);

    const onCheck = () => {
      if (checked) {
        setSelectedCompanySns(selectedCompanySns.filter((selectedCompanySn) => selectedCompanySn !== companySn));
      } else {
        const tempList = [...selectedCompanySns, companySn];
        setSelectedCompanySns(tempList);
      }
    };

    return (
      <label key={companySn} className={cx('label')}>
        <input type="checkbox" checked={checked} className={cx('hidden', 'input')} onChange={onCheck} />
        <span className={cx('checkbox')} />
        {companyName}
      </label>
    );
  });

  return (
    <div className={cx('selectWrap')} ref={positionSelectRef}>
      <a
        className={cx('btnSelect', { open: selectOptionAreaVisible }, { on: false })}
        onClick={() => setSelectOptionAreaVisible(!selectOptionAreaVisible)}
        role="button"
      >
        {selectText}
      </a>
      {selectOptionAreaVisible && (
        <div className={cx('selectOptionArea')}>
          <div className={cx('scrollArea')}>
            <div className={cx('selectOptionInner')}>{positionEl}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PositionSelect;
